import { render, staticRenderFns } from "./AncestrylineDataTable.vue?vue&type=template&id=4993bc1e&scoped=true&"
import script from "./AncestrylineDataTable.vue?vue&type=script&lang=js&"
export * from "./AncestrylineDataTable.vue?vue&type=script&lang=js&"
import style0 from "./AncestrylineDataTable.vue?vue&type=style&index=0&id=4993bc1e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4993bc1e",
  null
  
)

export default component.exports